import '../views/layout/app.html';
import '../views/layout/redirectInfo.html';
import pjson from '../../../package.json';
import { UserDetailsService } from 'fides-angularjs-components/src/fts-services/fts-user-details-service';
import { PortalService } from 'fides-angularjs-components/src/fts-administration/services/fts-portal-service';
import { HTTPServiceError } from "fides-angularjs-components/src/fts-services/fts-http-service-error";

import { CALENDAR_START_DAY_KEY } from "../common/filters/fsDateUtils";
import {
    signalApplicationHeaderDataReady
} from "../components/react/AwApplicationHeaderHelpers/AwApplicationHeaderHelpers";

export class MainController {
    constructor($rootScope, $scope, arsMainDependencies, userService, $cookies) {
        this.lngPromise = null;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.version = pjson.version;
        this.$state = arsMainDependencies.$state;
        this.ftsMainDependencies = userService.fsMainDependencies;
        this.modal = arsMainDependencies.$mdDialog;
        this.portalService = new PortalService(this.ftsMainDependencies);
        this.errorHandler = new HTTPServiceError(this.ftsMainDependencies, this.portalService);
        // Check user is in rootscope
        this.ftsMainDependencies.initCompletedPromise = this.ftsMainDependencies.$rootScope.user ?
          Promise.resolve() : this.portalService.appService.automaticLogin();
        this.ftsMainDependencies.initCompletedPromise.then(() => {
            this.appConfig = arsMainDependencies.ArsConfig;
            this.ftsMainDependencies.sessionPersistance.init(new UserDetailsService(userService));
            userService.promise.then(() => {
                const currLng = this.ftsMainDependencies.$rootScope.portalUser?.impersonatedUser
                  ? this.ftsMainDependencies.$rootScope.portalUser?.impersonatedUser.settings.language
                  : this.ftsMainDependencies.settings.language;
                this.lngPromise = this.ftsMainDependencies.$translate.use(currLng);
                // Initialize calendarStartDate refresh case uses $cookies stored calendarStartDate
                const calendarStarts = this.ftsMainDependencies.settings ?
                  JSON.parse(JSON.stringify(this.ftsMainDependencies.settings.calendarStartingDay)) :
                  JSON.parse(JSON.stringify($cookies.get(CALENDAR_START_DAY_KEY)));
                if (calendarStarts) {
                    // New deep clone copy
                    $cookies.put(CALENDAR_START_DAY_KEY, calendarStarts);
                }
                new PortalService(this.ftsMainDependencies)
                  .loadApplications()
                  .then(() => signalApplicationHeaderDataReady(this.$rootScope));
            })
        });

        this.ftsMainDependencies.$rootScope.$on('languageChange', () => {
            this.ftsMainDependencies.$translate.use(this.ftsMainDependencies.settings.language);
        });
    }
}
